import { useAsyncFileDownload } from '@/hooks/use-async-file-download';
import { requestGdprReport } from '@/services/api/gdpr';

interface GdprReport {
  isGenerating: boolean;
  generateReport: (justification: string) => Promise<void>;
}

/**
 * Async GDPR Article-15 report for a user: POSTs the request with the audit justification, then downloads
 * the PDF when the WS fileDownload push lands. Thin wrapper over useAsyncFileDownload.
 */
export const useGdprReport = (pid: string): GdprReport => {
  const { isPending, start } = useAsyncFileDownload<string>({
    request: (justification) => requestGdprReport(pid, justification),
    label: 'GDPR report',
  });

  return { isGenerating: isPending, generateReport: start };
};
